import { IUserInformation } from 'services/type'

const storageToken = 'user-information'

export function getUser() {
  const token = localStorage.getItem(storageToken)
  return (token === null ? undefined : JSON.parse(token)) as unknown as
    | undefined
    | IUserInformation
}

export function setUser(payload?: IUserInformation) {
  if (payload) {
    localStorage.setItem(storageToken, JSON.stringify(payload))
  } else {
    localStorage.removeItem(storageToken)
  }

  return payload
}
